import useAgencyInvoices from "../../datahooks/useAgencyInvoices";
import Invoices from "../Invoices";

export default function AgencyInvoices() {
  const {
    agencyInvoices,
    isLoadingAgencyInvoices,
    isAgencyInvoicesError,
    refetchAgencyInvoices,
  } = useAgencyInvoices();

  return (
    <Invoices
      invoices={agencyInvoices}
      isLoadingInvoices={isLoadingAgencyInvoices}
      isInvoicesError={isAgencyInvoicesError}
      refetchInvoices={refetchAgencyInvoices}
    />
  );
}
